export default class {
    constructor() {
        // Constants
        this.DEFAULT_IMAGE_NAME = '/assets/img/tin/Empty-Background.png';

        // Values
        this.name           = '';
        this.description    = '';
        this.image          = this.DEFAULT_IMAGE_NAME;
        this.primary        = '#E20000';
        this.secondary      = '#FAB7FC';
        this.opacity        = 1;
    }
    set name(name) {
        this._name = (name || '').toUpperCase();
    }
    get name() {
        return this._name;
    }
    set description(description) {
        this._description = description;
    }
    get description() {
        return this._description;
    }
    set image(image) {
        this._image = image;
    }
    get image() {
        return this._image;
    }
    set primary(color) {
        this._primary = color;
    }
    get primary() {
        return this._primary;
    }
    set secondary(color) {
        this._secondary = color;
    }
    get secondary() {
        return this._secondary;
    }
    set opacity(opacity) {
        this._opacity = opacity;
    }
    get opacity() {
        return this._opacity;
    }
    get values() {
        return {

        }
    }
}